module.exports = __webpack_public_path__ + "img/electroWheel.e10d4ecf.svg";